// import constants
import { CONDITION_COMPARE_TYPE } from '../Constants/Constants';

const HIGH_ALERT = '#f6d8d9';

// Alert highlight cell
// return as string Object
export const AlertHighlightCell = (data, Compare, condition) => {
  const type_Of = typeof data;
  const alert = { backgroundColor: HIGH_ALERT };
  let ret = {};
  if (type_Of === 'string') {
    if (Compare === CONDITION_COMPARE_TYPE.EQUAL) {
      ret = data === condition ? alert : {};
    }
  } else if (type_Of === 'boolean') {
    if (Compare === CONDITION_COMPARE_TYPE.EQUAL) {
      ret = data === condition ? alert : {};
    }
  } else if (type_Of === 'number') {
    if (Compare === CONDITION_COMPARE_TYPE.GREATER) {
      ret = data > condition ? alert : {};
    } else if (Compare === CONDITION_COMPARE_TYPE.LESS) {
      ret = data < condition ? alert : {};
    } else {
      ret = data === condition ? alert : {};
    }
  }
  return ret;
};

// Alert highlight cell
// return as string Object
export const AlertBoldTextCell = (data, Compare, condition) => {
  const type_Of = typeof data;
  let ret = {};
  if (type_Of === 'string') {
    if (Compare === CONDITION_COMPARE_TYPE.EQUAL) {
      ret = data === condition;
    }
  } else if (type_Of === 'boolean') {
    if (Compare === CONDITION_COMPARE_TYPE.EQUAL) {
      ret = data === condition;
    }
  } else if (type_Of === 'number') {
    if (Compare === CONDITION_COMPARE_TYPE.GREATER) {
      ret = data > condition;
    } else if (Compare === CONDITION_COMPARE_TYPE.LESS) {
      ret = data < condition;
    } else {
      ret = data === condition;
    }
  }
  return ret;
};



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/Utilities/CellStyle.js